<template>
  <div class="p-prepare">
    <div v-if="gradeList.length > 0">
      <header class="p-prepare-header">
      <div class="p-prepare-grade" ref="allGrade">
        <span class="grade-type p-0">年级:</span>
        <div style="flex: 1;">
          <div ref="grade">
            <span v-for="(item,i) in gradeList" :key="i"
            class="grade-type pointer"
            :class="[{'active':Number(item.grade_id)===Number(gradeId)},
            'grade-item']"
            @click="gradeClick(item)"
            >{{item.grade_name}}
            </span>
          </div>
        </div>
        <div class="grade-unfold">
          <span
            class="s-form-item__label blue pointer"
            v-if="!unfoldGrade && unfoldGradeShow"
            @click="unfold('grade')"> 展开
            <i class="el-icon-caret-bottom"></i>
          </span>
          <span
            class="s-form-item__label blue pointer"
            v-if="!unfoldGrade && !unfoldGradeShow"
            @click="packUp('grade')"> 收起
            <i class="el-icon-caret-top"></i>
          </span>
        </div>
      </div>
      <div class="p-prepare-class" ref="allClass">
        <span class="class-type p-0">班级:</span>
        <div style="flex: 1;">
          <div ref="class">
            <span v-for="(item,i) in classList" :key="i"
            class="class-type pointer"
            :class="[{'active':item.class_id==classId},'class-item']"
            @click="classClick(item)"
            >{{item.class_name}} </span>
            </div>
        </div>
        <div class="grade-unfold">
          <span
            class="s-form-item__label blue pointer"
            v-if="!unfoldClass && unfoldClassShow"
            @click="unfold('class')"> 展开
            <i class="el-icon-caret-bottom"></i>
          </span>
          <span
            class="s-form-item__label blue pointer"
            v-if="!unfoldClass && !unfoldClassShow"
            @click="packUp('class')"> 收起
            <i class="el-icon-caret-top"></i>
          </span>
        </div>
      </div>
    </header>
    <div v-if="classList.length > 0">
      <el-tabs v-model="activeName"
    @tab-click="onTabClick" class="mt-24 i-tab" :class="offsetClass">
      <el-tab-pane
        :label="item.label"
        :name="item.name"
        :lazy="item.name === 'TestAnalysis' || item.name === 'JobAnalysis'"
        v-for="item in tabList"
        :key="item.name">
          <component
            ref="PreviewRecord"
            :is="item.component"
            :gradeId="gradeId"
            :classId="classId"
            :masterClassId='masterClassId'
            :classCreateTime="classCreateTime"
            />
        </el-tab-pane>
    </el-tabs>
    </div>
    <div v-else>
      <empty content="未查询到您有任教的班级," lastContent="请联系校区管理员为您分配班级" :show="false" />
    </div>
    </div>
    <div v-else>
      <empty content="未查询到您有任教的班级," lastContent="请联系校区管理员为您分配班级" :show="false" />
    </div>
  </div>
</template>

<script>
import { userAgentType } from '@/utils/index';
import AdaptAnalysis from './adapt-analysis.vue';
import Empty from '@/views/pt/components/empty.vue';
import StudentTrack from './student-track.vue';
import TestAnalysis from './test-analysis.vue';
import JobAnalysis from './job-analysis.vue';
import { getYearClass } from '@/api/pt';
import { unlocking } from '@/utils/access-control';

export default {
  name: 'StudentAnalysis',
  components: {
    StudentTrack,
    AdaptAnalysis,
    TestAnalysis,
    JobAnalysis,
    Empty,
  },
  data() {
    return {
      activeName: 'AdaptAnalysis',
      offsetClass: 'l-0',
      tabList: [{
        label: '智适应分析',
        name: 'AdaptAnalysis',
        component: AdaptAnalysis,
      }, {
        label: '精准测评分析',
        name: 'TestAnalysis',
        component: TestAnalysis,
      }, {
        label: '练习分析',
        name: 'JobAnalysis',
        component: JobAnalysis,
      }],
      gradeId: null,
      classId: null,
      masterClassId: null,
      gradeList: [],
      classList: [],
      unfoldGradeShow: true,
      unfoldClassShow: true,
      unfoldClass: false,
      unfoldGrade: false,
    };
  },
  mounted() {
    const userAgent = userAgentType();
    console.log(userAgent);
    this.getYearClass();
  },
  computed: {
    classCreateTime() {
      if (this.classList.length > 0) {
        const list = this.classList.filter((item) => item.class_id === this.classId);
        return list[0] && list[0].class_create_time;
      }
      return '';
    },
  },
  watch: {
    gradeList() {
      this.$nextTick(() => {
        console.log(this.$refs.grade.offsetHeight, 66);
        if (this.$refs.grade && this.$refs.grade.offsetHeight < 70) {
          console.log(3);
          this.unfoldGrade = true;
        } else {
          console.log(4);
          this.unfoldGrade = false;
        }
      });
    },
    classList() {
      this.$nextTick(() => {
        if (this.$refs.class && this.$refs.class.offsetHeight < 70) {
          this.unfoldClass = true;
        } else {
          this.unfoldClass = false;
        }
      });
    },
  },
  methods: {
    unfold(type) {
      if (type === 'grade') {
        this.unfoldGradeShow = false;
        this.$refs.allGrade.style.height = `${this.$refs.grade.offsetHeight}px`;
      }
      if (type === 'class') {
        console.log(this.$refs.class.offsetHeight);
        this.unfoldClassShow = false;
        this.$refs.allClass.style.height = `${this.$refs.class.offsetHeight}px`;
      }
    },
    packUp(type) {
      if (type === 'grade') {
        this.unfoldGradeShow = true;
        this.$refs.allGrade.style.height = '67px';
      }
      if (type === 'class') {
        this.unfoldClassShow = true;
        this.$refs.allClass.style.height = '67px';
      }
    },
    onTabClick(e) {
      this.offsetClass = `l-${e.index}`;
    },
    async gradeClick(item) {
      this.gradeId = item.grade_id;
      const isCharge = unlocking('Master_Sale_Manager') ? 1 : 0;
      const res = await getYearClass({
        is_charge: isCharge,
        grade_id: this.gradeId,
      });
      this.classList = res.data.class_list;
      this.classId = (this.classList[0] && this.classList[0].class_id);
      this.masterClassId = (this.classList[0] && this.classList[0].school_master_class_id);
    },
    classClick(item) {
      this.classId = item.class_id;
      this.masterClassId = item.school_master_class_id;
    },
    async getYearClass(type) {
      const isCharge = unlocking('Master_Sale_Manager') ? 1 : 0;
      const res = await getYearClass({
        is_charge: isCharge,
        grade_id: this.gradeId || 0,
      });
      this.classList = res.data.class_list;
      this.classId = this.$route.query.classId
        || (this.classList[0] && this.classList[0].class_id);
      this.masterClassId = (this.$route.query.masterClassId === 0 ? '' : this.$route.query.masterClassId)
        || (this.classList[0] && this.classList[0].school_master_class_id);
      if (!type) {
        this.gradeList = res.data.grade_list;
        this.gradeId = this.$route.query.gradeId || this.gradeList[0].grade_id;
        this.getYearClass(true);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.p-prepare{
  padding: 0px 24px;
  height: 100%;
  box-sizing: border-box;
  overflow-y: auto;
  background: #fff;
  position: relative;
  .p-0 {
    padding: 0 12px !important;
  }
   &-header{
    border-bottom:8px solid #EEF2F9FF ;
    .p-prepare-grade{
      display: flex;
      overflow: hidden;
      height: 67px;
      width: 100%;
      line-height: 67px;
      border-bottom:1px dashed #DCE1EB ;
      .grade-type{
        padding: 7px 12px;
        font-size: 16px;
        color: #000000;
        margin-right:20px ;
      }
      .grade-circle{
         width: 4px;
          height: 4px;
          background: #C0C4CC;
          border-radius: 50%;
      }
    }
   }
   .grade-unfold {
        width: 105px;
        color: rgba(25, 137, 250, 1);
      }
     .p-prepare-class{
       display: flex;
       overflow: hidden;
      height: 67px;
      width: 100%;
      line-height: 67px;
      .class-type{
        padding: 7px 12px;
        font-size: 16px;
        color: #000000;
        margin-right:20px ;
      }
    }
    .grade-item, .class-item {
      &:hover {
        color: rgba(25, 137, 250, 1);
      }
    }
     .active{
      border-radius: 5px;
      background-color: rgba(25, 137, 250, 1);
      color: #fff !important;
      font-weight: 500;
      &:hover {
        color: #fff !important;
      }
    }
  }
// element tag 样式覆盖
.i-tab {
  /deep/ {
    .el-tabs__item {
      font-size: 17px;
      width: 100px;
      text-align: center;
      height: 56px;
      line-height: 56px;
      padding: 0 !important;
      margin: 0 20px;
      &.is-active {
        color: rgba(25, 137, 250, 1);
      }
    }
    .el-tabs__nav-wrap {
      overflow: visible;
      display: flex;
    }
    .el-tabs__nav-scroll {
      overflow: visible;
    }
    .el-tabs__active-bar {
      background-color: rgba(25, 137, 250, 1);
      height: 3px;
      border-radius: 2px;
      width: 100px !important;
      &::after {
        content: '';
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        width: 13px;
        height: 13px;
        border: 2px solid rgba(25, 137, 250, 1);
        box-sizing: border-box;
        background: #fff;
        border-radius: 50%;
        top: -4px;
      }
    }
  }
}
.l-0 /deep/{
  .el-tabs__active-bar {
    left: 18px;
  }
}
.l-1 /deep/ {
  .el-tabs__active-bar {
    left: 60px;
  }
}
.l-2 /deep/ {
  .el-tabs__active-bar {
    left: 96px;
  }
}
.l-3 /deep/ {
  .el-tabs__active-bar {
    left: 138px;
  }
}
.l-4 /deep/ {
  .el-tabs__active-bar {
    left: 180px;
  }
}
</style>
